const subjects = {
  geography: { en: 'National Geography', zhhk: '國家地理' },
  economicDevelop: { en: 'Economic Development', zhhk: '經濟發展' },
  society: { en: 'Society Today', zhhk: '社會新貌' },
  technological: { en: 'Technological Achievements', zhhk: '科技成就' },
};

export { subjects };
export default subjects;
